module.exports = __webpack_public_path__ + "img/lb.ddf99520.png";